import React, { useEffect, useState, useRef, useMemo } from 'react';
import { ConnectWebSocketForOverlay, DisconnectWebSocket, SetSocketMessageHandler, ClearSocketMessageHandler } from './../../../utilities/BL/Zones';
import { GetRouletteConfig } from './../../../utilities/BL/Roulette';


const Roulette = ({ screenId = 1, isStandalone = true, payload = null }) => {
    const [connectionStatus, setConnectionStatus] = useState('idle');
    const [statusMessage, setStatusMessage] = useState('¡LISTO PARA GIRAR!');
    const [prizes, setPrizes] = useState([]);
    const [spinDuration, setSpinDuration] = useState(5000);
    const [scale, setScale] = useState(100);
    const [rotation, setRotation] = useState(0);
    const [isSpinning, setIsSpinning] = useState(false);
    const [winnerData, setWinnerData] = useState(null);

    const rouletteRef = useRef(null);

    // Cargar la configuración visual desde la base de datos
    const fetchConfig = async () => {
        const res = await GetRouletteConfig(screenId);
        if (res && res.success && res.data) {
            setPrizes(res.data.prizes || []);
            setSpinDuration(res.data.spinDurationMs || 5000);
            setScale(res.data.scale || 100);
        }
    };

    useEffect(() => {
        fetchConfig();

        if (!isStandalone) return;

        const connectWS = async () => {
            const overlayType = `roulette:screen:${screenId}`;
            await ConnectWebSocketForOverlay(overlayType, (status) => setConnectionStatus(status), (msg) => console.log(msg));
            SetSocketMessageHandler(handleIncomingMessage);
        };

        connectWS();

        return () => {
            ClearSocketMessageHandler();
            DisconnectWebSocket();
        };
    }, [screenId, isStandalone]);

    // Escuchar órdenes si viene incrustado en el Canvas general del Estadio
    useEffect(() => {
        if (!isStandalone && payload) handleIncomingMessage(payload);
    }, [payload, isStandalone]);

    const handleIncomingMessage = (message) => {
        if (!message || !message.type) return;

        switch (message.type.toLowerCase()) {
            case 'roulette.prepare':
                fetchConfig();
                resetRoulette();
                break;
            case 'roulette.spin':
                executeSpinAnimation(message.payload || message.data);
                break;
            default:
                break;
        }
    };

    const resetRoulette = () => {
        setRotation(0);
        setIsSpinning(false);
        setWinnerData(null);
        setStatusMessage('¡LISTO PARA GIRAR!');
    };

    // const executeSpinAnimation = (spinData) => {
    //     if (isSpinning) return;
        
    //     const { prizeWon, isWinner, spinDurationMs, playerName } = spinData;
    //     setIsSpinning(true);
    //     setStatusMessage('¡GIRANDO LA SUERTE...!');
    //     setWinnerData(null);

    //     // Buscar el índice del premio que C# determinó como ganador
    //     const targetIndex = prizes.findIndex(p => p.text === prizeWon);
    //     if (targetIndex === -1) {
    //         setIsSpinning(false);
    //         return;
    //     }

    //     const sliceSize = 360 / prizes.length;
    //     // Física de la ruleta: Vueltas completas base (5 a 8 vueltas) + cálculo inverso para que frene arriba (puntero a las 12 en punto)
    //     const extraTurns = (4 + Math.floor(Math.random() * 4)) * 360;
    //     const targetAngle = extraTurns + (360 - (targetIndex * sliceSize) - (sliceSize / 2));

    //     setRotation(targetAngle);

    //     // Al finalizar el tiempo de animación asignado por el Admin
    //     setTimeout(() => {
    //         setIsSpinning(false);
    //         setWinnerData({ prizeWon, isWinner, playerName });
    //         setStatusMessage(isWinner ? `🎉 ¡FELICIDADES ${playerName}! 🎉` : '😔 SUERTE PARA LA PRÓXIMA 😔');
    //     }, spinDurationMs);
    // };

    // 2. Lógica de giro corregida (Asegura siempre dirección horaria)
    const executeSpinAnimation = (spinData) => {
        if (isSpinning) return;
        
        const { prizeWon, spinDurationMs } = spinData;
        setIsSpinning(true);
        setStatusMessage('¡GIRANDO!');
        setWinnerData(null);

        const targetIndex = prizes.findIndex(p => p.text === prizeWon);
        const sliceSize = 360 / prizes.length;
        
        // Calculamos el ángulo para que el puntero (las 12) quede en el centro de la rebanada
        // Usamos rotación acumulativa para que siempre gire en sentido horario
        const offset = (targetIndex * sliceSize) + (sliceSize / 2);
        const newRotation = rotation + (5 * 360) + (360 - offset - rotation % 360);

        setRotation(newRotation);

        setTimeout(() => {
            setIsSpinning(false);
            setWinnerData({ prizeWon });
        }, spinDurationMs);
    };

    // Construcción del degradado cónico CSS dinámico basado en las rebanadas del Admin
    // const wheelStyle = useMemo(() => {
    //     if (!prizes.length) return {};
    //     const slicePercent = 100 / prizes.length;
    //     let gradientParts = [];
        
    //     prizes.forEach((prize, index) => {
    //         const start = index * slicePercent;
    //         const end = (index + 1) * slicePercent;
    //         gradientParts.push(`${prize.backgroundColor} ${start}% ${end}%`);
    //     });

    //     return {
    //         background: `conic-gradient(${gradientParts.join(', ')})`,
    //         transform: `rotate(${rotation}deg)`,
    //         transition: isSpinning ? `transform ${spinDuration}ms cubic-bezier(0.1, 0.8, 0.1, 1)` : 'none'
    //     };
    // }, [prizes, rotation, isSpinning, spinDuration]);

    // const wheelStyle = useMemo(() => {
    //     if (!prizes.length) return {};
        
    //     // 1. División equitativa automática (100% / N)
    //     const slicePercent = 100 / prizes.length;
    //     let gradientParts = [];
        
    //     prizes.forEach((prize, index) => {
    //         // 2. Patrón Rojo - Blanco automático
    //         const color = (index % 2 === 0) ? '#db166c' : '#ffffff'; 
    //         const start = index * slicePercent;
    //         const end = (index + 1) * slicePercent;
    //         gradientParts.push(`${color} ${start}% ${end}%`);
    //     });

    //     return {
    //         background: `conic-gradient(${gradientParts.join(', ')})`,
    //         transform: `rotate(${rotation}deg)`,
    //         transition: isSpinning ? `transform ${spinDuration}ms cubic-bezier(0.1, 0.8, 0.1, 1)` : 'none'
    //     };
    // }, [prizes, rotation, isSpinning, spinDuration]);

    // 1. Modifica el estilo de la ruleta (wheelStyle)
    const wheelStyle = useMemo(() => {
        if (!prizes.length) return {};
        const slicePercent = 100 / prizes.length;
        let gradientParts = [];
        
        prizes.forEach((prize, index) => {
            // Patrón Rojo (#db166c) y Negro (#000000)
            const color = (index % 2 === 0) ? '#dc2626' : '#000000'; 
            const start = (index * slicePercent) + 0.5; 
            const end = ((index + 1) * slicePercent) - 0.5;
            gradientParts.push(`${color} ${start}% ${end}%`);
        });

        return {
            background: `conic-gradient(from 0deg, ${gradientParts.join(', ')})`,
            backgroundColor: '#000',
            transform: `rotate(${rotation}deg)`,
            // Transición constante y suave
            transition: isSpinning ? `transform ${spinDuration}ms cubic-bezier(0.2, 0, 0.2, 1)` : 'none',
            border: '10px solid #fff'
        };
    }, [prizes, rotation, isSpinning, spinDuration]);

    return (
        <div style={{ position: 'relative', width: '100vw', height: '100vh', overflow: 'hidden', backgroundColor: '#111', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            
            {/* VIDEO DE FONDO */}
            <div className='SelfieFan__Screen__QR__Background'>
                <video 
                    src='/img/page/backgrounds/Fondo-SelfieFan-Varonil-Cadenas-Zoom-Master-2.mp4' 
                    className='SelfieFan__Screen__QR__Background__Video' 
                    autoPlay loop muted playsInline 
                />
            </div>

            {/* TEXTOS SUPERIORES DE CASINO */}
            <div style={{ position: 'absolute', top: '5%', zIndex: 10, textAlign: 'center', color: 'white' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#fff', color: '#dc2626', padding: '4px 30px', borderRadius: '6px' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {/* <h1 style={{ fontSize: '3.5rem', fontWeight: 'bold', textTransform: 'uppercase', textShadow: '0 0 20px #db166c', marginBottom: '0' }}>Ruleta</h1> */}
                        <h1 style={{ fontSize: '4rem', fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '0' }}>Ruleta</h1>
                        <img src='/img/games/roulette/xoloshop-logo.PNG' style={{ width: '200px', marginLeft: '15px' }} />
                    </div>
                    <div className='d-flex align-items-center'>
                        <span className='text-dark'>Hecho con ♥ por </span><img src="/img/page/xolos-five-black.png" alt="Logo" style={{ maxWidth: '200px', marginBottom: '10px' }} />
                    </div>
                </div>
                {/* <div style={{ backgroundColor: 'rgba(0,0,0,0.6)', padding: '10px 30px', borderRadius: '50px', fontSize: '1.8rem', color: '#ffb300', fontWeight: 'bold', border: '2px solid #db166c', display: 'inline-block', marginTop: '10px' }}>
                    {statusMessage}
                </div> */}
            </div>

            {/* CONTENEDOR PRINCIPAL CON ESCALA (ZOOM ADM) */}
            <div style={{ transform: `scale(${scale / 100})`, position: 'relative', width: '600px', height: '600px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '160px' }}>
                
                {/* PUNTERO DE SELECCIÓN (Estilo Flecha Casino en la parte superior) */}
                <div style={{ position: 'absolute', top: '-140px', zIndex: 100, width: '0', height: '0', borderLeft: '30px solid transparent', borderRight: '30px solid transparent', borderTop: '50px solid #ffffff', filter: 'drop-shadow(0px 4px 10px rgba(0,0,0,0.7))' }} />

                {/* CUERPO DE LA RULETA */}
                <div ref={rouletteRef} style={{ ...wheelStyle, position: 'absolute', width: '850px', height: '850px', borderRadius: '50%', border: '15px solid #111', boxShadow: '0 0 50px rgba(219,22,108,0.4)', overflow: 'hidden' }}>
                    {/* Textos dentro de cada rebanada */}
                    {/* {prizes.map((prize, idx) => {
                        const angle = (360 / prizes.length) * idx + (360 / prizes.length) / 2;
                        return (
                            <div key={prize.id || idx} style={{ position: 'absolute', width: '50%', height: '60px', top: 'calc(50% - 30px)', left: '50%', transformOrigin: '0% 50%', transform: `rotate(${angle - 90}deg) translateX(60px)`, display: 'flex', alignItems: 'center', color: prize.textColor || '#fff', fontWeight: 'bold', fontSize: '1.2rem', paddingLeft: '40px', whiteSpace: 'nowrap', userSelect: 'none' }}>
                                {prize.text}
                            </div>
                        );
                    })} */}

                    {prizes.map((prize, idx) => {
                        const angle = (360 / prizes.length) * idx + (360 / prizes.length) / 2;
                        return (
                            <div key={prize.id || idx} style={{ 
                                position: 'absolute', 
                                width: '45%', // Un poco menos para que el texto no toque el borde
                                height: '100px', // Aumentamos la altura para dar espacio a dos líneas
                                top: 'calc(50% - 50px)', 
                                left: '50%', 
                                transformOrigin: '0% 50%', 
                                transform: `rotate(${angle - 90}deg) translateX(70px)`, // Desplazamos más afuera para mejor lectura
                                display: 'flex', 
                                flexDirection: 'column', // <-- ESTO PONE EL TEXTO EN LÍNEAS
                                justifyContent: 'center', 
                                alignItems: 'flex-start', // Alineado a la izquierda para que empiece bien
                                color: prize.textColor || '#fff', 
                                fontWeight: 'bold', 
                                fontSize: '1.8rem', 
                                paddingLeft: '10px', 
                                lineHeight: '1.2', // Reduce el espacio entre líneas para que se vean compactas
                                textAlign: 'left',
                                wordWrap: 'break-word',
                                pointerEvents: 'none' // Para que no estorbe en los clics
                            }}>
                                {prize.text}
                            </div>
                        );
                    })}
                </div>

                {/* CENTRO DE LA RULETA DE METAL */}
                <div style={{ position: 'absolute', width: '90px', height: '90px', backgroundColor: '#222', borderRadius: '50%', border: '6px solid #ffb300', boxShadow: 'inset 0 0 15px rgba(255,255,255,0.2), 0 4px 15px rgba(0,0,0,0.6)', zIndex: 50, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ width: '40px', height: '40px', backgroundColor: '#ffb300', borderRadius: '50%' }} />
                </div>
            </div>

            {/* POPUP DE GANADOR GIGANTE INMERSIVO */}
            {/* {winnerData && (
                <div style={{ position: 'absolute', bottom: '8%', backgroundColor: 'rgba(0,0,0,0.85)', padding: '20px 50px', borderRadius: '20px', border: '3px solid #ffb300', textAlign: 'center', color: 'white', animation: 'fadeIn 0.5s ease', boxShadow: '0 0 40px rgba(255,179,0,0.3)', zIndex: 200 }}>
                    <h2 style={{ fontSize: '2.5rem', color: '#ffb300', fontWeight: 'bold', marginBottom: '5px' }}>{winnerData.playerName} se lleva:</h2>
                    <p style={{ fontSize: '3.5rem', margin: 0, fontWeight: 'black', textTransform: 'uppercase', color: '#fff' }}>{winnerData.prizeWon}</p>
                </div>
            )} */}
            {/* GANADOR (Solo este letrero abajo) */}
            {winnerData && (
                <div style={{ position: 'absolute', bottom: '10%', width: '100%', textAlign: 'center', zIndex: 200 }}>
                    <div style={{ display: 'inline-block', padding: '20px 40px', backgroundColor: 'rgba(0,0,0,0.8)', border: '4px solid #ffb300', borderRadius: '15px' }}>
                        {/* <h2 style={{ fontSize: '2rem', color: '#ffb300', margin: 0 }}>¡Felicidades! Has ganado</h2> */}
                        <p style={{ fontSize: '3rem', fontWeight: 'bold', color: 'white', margin: 0 }}>{winnerData.prizeWon}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export { Roulette };